import React from 'react'
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { API_URL } from '../settings';
import { useAuth } from '../Hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import styles from "./Login.module.css"
import logo from "../img/logo1.png"

const Login = () => {
    const { setUser } = useAuth()
    const navigate = useNavigate()    
    
    const googleLogin = useGoogleLogin({ 
        onSuccess: async ({ code }) => await axios.post(`${API_URL}/auth/google-authentication`, { code })
        .then(res => {
            setUser(res)
            navigate("/users")
        })
        .catch(error => console.log(error)), 
        flow: 'auth-code' 
    })

    return (
        <main>
            <div className={styles.itemsContainer}>
                <img src={logo} className={styles.image} />
                <button className={styles.button} onClick={() => googleLogin()}>
                    Sign in with Google 🚀{' '}
                </button>
            </div>
        </main>

    )
}
export default Login;